module.exports = __webpack_public_path__ + "static/media/data.87e06d7f.png";